import { useEffect } from "react";
import { Coins } from "lucide-react";
import { useAuthStore } from "@/features/auth/auth-store";
import { apiGetMe } from "@/features/auth/api";

export const CommonHeader = () => {
  const token = useAuthStore((s) => s.token);
  const chips = useAuthStore((s) => s.user?.chips);
  const updateUser = useAuthStore((s) => s.updateUser);

  useEffect(() => {
    if (!token) return;
    apiGetMe(token)
      .then((data) => updateUser({ chips: data.chips }))
      .catch((err) => console.warn("Failed to refresh chip balance:", err.message));
  }, [token, updateUser]);

  return (
    <header className="sticky top-0 z-50 w-full bg-transparent">
      <div className="container flex h-16 max-w-screen-2xl items-center justify-start px-4">
        <div className="flex items-center gap-2 rounded-full border border-border bg-card/80 px-4 py-2 backdrop-blur-sm" aria-label={`Chip balance: ${chips != null ? chips.toLocaleString() : 'loading'}`}>
          <Coins className="h-5 w-5 text-secondary" />
          <span className="font-bold text-lg text-secondary">
            {chips != null ? chips.toLocaleString() : "---"}
          </span>
        </div>
      </div>
    </header>
  );
};
